import * as React from 'react';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import Button from '../../../../../common/components/Button';
import {
    CALCULATOR,
    CALCULATOR_MX,
    ERROR,
    GLOBAL
} from '../../../../constants/LabelConstants';
import {formatCurrency} from '../../../../utils/CurrencyUtils';
import {
    CalculatorProfile,
    CalculatorProfileStepState
} from '../../../../types/mx/creditoReal/components';
import OptionsMonthly from '../../../../../common/components/OptionsMonthly';
import {Catalog} from '../../../../../common/types/common';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import InputRange from '../../../../../common/components/InputRange';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import Options from '../../../../../common/components/Options';
import {splitDecimal} from '../../../../../common/utils/NumberUtils';
import {COUNTRY_INITIALS} from '../../../../../common/constants/AppConstants';

class SimulatorProfileView extends React.Component<CalculatorProfile, CalculatorProfileStepState> {

    constructor(props) {
        super(props);
        this.state = {
            showErrors: false
        };
        const actions = [this.props.fillcalculator(), this.props.getCalculatorQuotes()];
        actions.map(() => setTimeout((fun) => {
            setTimeout(fun, 500);
        }));
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
        }, 200);
    }

    onPressAcceptQuote = () => {
        this.setState({showErrors: true}, this.checkIfPressNext);
    }

    checkIfPressNext = () => {
        if (this.props.hasCalculatorFieldsError) {
            return this.props.onPressAcceptQuote();
        }
    }

    renderQuotas = () => {
        const {
            defaultMonthlyPayment,
            monthlyPayments,
            monthlyPaymentField,
            hasInsurance
        } = this.props;
        const defaultMonthlyPaymentItem = defaultMonthlyPayment.find((monthlyPayment, index) => index === 0);
        const monthlyQuotaValue = !!monthlyPayments ? monthlyPayments.find(monthlyPayment =>
            monthlyPayment.value === monthlyPaymentField.value.value
        ) : '';
        const annualInsurance = <div className="row section-details border-bottom mt-3 pb-3">
            <div className="col">
                <div className="row">
                    <div className="col title">{CALCULATOR_MX.ANNUAL_INSURANCE}</div>
                </div>
                {this.props.isInsuranceInFinancing &&
                    <div className="row mt-2 mb-2">
                        <div className="col description">
                            {CALCULATOR_MX.ANNUAL_INSURANCE_INCLUDED_MONTHLY_PAYMENT}
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col value">
                        {this.props.insuranceAmount || '$ — —'}
                    </div>
                </div>
            </div>
        </div>;
        return <React.Fragment>
            <div className="row monthly-quotes">
                <div className="col">
                    <div className="row">
                        <div className="col title-quotes">{CALCULATOR_MX.MONTHLY_PAYMENTS_SIMULATOR}</div>
                    </div>
                    {!monthlyQuotaValue && <div className="row pb-2">
                        <div className="col sub-title-quotes d-flex align-items-center justify-content-center">
                            {CALCULATOR_MX.MONTHLY_PAYMENTS_DETAIL_SIMULATOR}
                        </div>
                    </div>}
                    {monthlyQuotaValue && <div className="row pb-2">
                        <div className="col value-quotes d-flex align-items-center justify-content-center">
                            {!!monthlyQuotaValue.label && splitDecimal(monthlyQuotaValue.label[1]).integerPart}
                        </div>
                    </div>}
                    <div className="row">
                        <div className="col">
                            <OptionsMonthly id={'quotas'}
                                            name={'quotas'}
                                            options={this.props.monthlyPayments || this.props.defaultMonthlyPayment}
                                            required={true}
                                            hasError={this.state.showErrors}
                                            labelError={this.props.monthlyPaymentField.error}
                                            onChange={this.props.onChangeMonthlyPayment}
                                            defaultValue={this.props.monthlyPaymentField.value.value ||
                                            defaultMonthlyPaymentItem.value}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row financing-details">
                <div className="col">
                    <div className="row">
                        <div className="col">
                            {hasInsurance && annualInsurance}
                            <div className="row section-details mt-2 pb-2">
                                <div className="col">
                                    <div className="row">
                                        <div className="col title">{CALCULATOR_MX.FINANCING_AMOUNT}</div>
                                    </div>
                                    <div className="row mt-2 mb-2">
                                        <div className="col description">
                                            {`${hasInsurance ? CALCULATOR_MX.FINANCING_AMOUNT_DOWNPAYMENT_INSURANCE_DETAIL : CALCULATOR_MX.FINANCING_AMOUNT_DOWNPAYMENT_WITHOUT_INSURANCE_DETAIL}`}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col value">
                                            {this.props.financingAmount || '$ — —'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col title-header">{CALCULATOR_MX.CASH_PAYMENTS}:</div>
                            </div>
                            {!hasInsurance && annualInsurance}
                            <div className="row section-details mt-2 pb-3">
                                <div className="col">
                                    <div className="row">
                                        <div className="col title">
                                            {CALCULATOR_MX.COMMISSION_AMOUNT}
                                        </div>
                                    </div>
                                    <div className="row mt-2 mb-2">
                                        <div className="col description">
                                            {CALCULATOR_MX.COMMISSION_AMOUNT_DETAIL_SIMULATOR}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col value">
                                            {this.props.commissionAmount || '$ — —'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }

    onChangeYear = (year: number, error: string, maxYear: number) => {
        const {onChangeYear, years} = this.props;
        const yearLength: number = year.toString().length;
        const strMaxYear: string = maxYear.toString();
        const strYear: string = year.toString();
        const maxYearCatalog = !!!year ? {id: strMaxYear, value: strMaxYear, payload: ''} : {
            id: strYear,
            value: strYear,
            payload: ''
        };
        if (yearLength === 4) {
            const yearFound: Catalog = years.find(y => y.value === strYear);
            const yearSelected = !!yearFound ? yearFound : maxYearCatalog;
            const newError: string = !!yearFound ? error : ValidateConstant.YEAR_OUT_OF_RANGE;

            onChangeYear(yearSelected, newError);
        } else {
            onChangeYear(maxYearCatalog, !!year ? error : null);
        }
    }

    render() {
        const {
            priceField, minPrice, years, yearSelectedField, monthlyRate, minDownPaymentValue, maxDownPayment,
            downPaymentField
        } = this.props;
        const priceSelected: string = priceField.value;
        const yearValues: number[] = years.length > 0 ? years.map(y => parseInt(y.value, 10)) : [0];
        const minYear: number = Math.min(...yearValues);
        const maxYear: number = Math.max(...yearValues);
        const selectedYear: string = yearSelectedField.value.value;
        const maxRange: number = Math.trunc(parseFloat(priceSelected) * maxDownPayment) || 0;
        const downPaymentSelected: string = downPaymentField.value;
        return (
            <React.Fragment>
                <div className="d-lg-none d-xl-none mb-3 motorfy-logo-turbo">
                    <img src={AssetsManager('/assets/images/wizard/motorfy-iso-primary.svg')} alt=""/>
                </div>
                <div className="wizard-turbo-title">
                    <h3 className="mt-4 mb-1 text-raleway text-secondary-lighten-1">
                        ¡Estás a un paso de conseguir tu crédito!
                    </h3>
                    <span className="regular-text sub-title">
                        Las siguientes condiciones están adaptadas a tu perfil crediticio
                    </span>
                </div>
                <div className="wizard-turbo">
                    <div className="row m-0 p-0">
                        <div className="col side-form">
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'brand'}
                                        label={CALCULATOR.BRAND}
                                        placeholder={GLOBAL.SELECT}
                                        value={this.props.brandSelectedField.value}
                                        data={this.props.brands}
                                        required={true}
                                        disabled={true}
                                        onChange={this.props.onChangeBrand}
                                        labelError={this.props.brandSelectedField.error}
                                        hasError={this.state.showErrors}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'model'}
                                        label={CALCULATOR.MODEL}
                                        placeholder={GLOBAL.SELECT}
                                        disabled={true}
                                        value={this.props.modelSelectedField.value}
                                        data={this.props.models}
                                        required={true}
                                        onChange={this.props.onChangeModel}
                                        labelError={this.props.modelSelectedField.error}
                                        hasError={this.state.showErrors}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'version'}
                                        label={CALCULATOR.VERSION}
                                        placeholder={GLOBAL.SELECT}
                                        value={this.props.versionSelectedField.value}
                                        data={this.props.versions}
                                        required={true}
                                        disabled={true}
                                        onChange={this.props.onChangeVersion}
                                        labelError={this.props.versionSelectedField.error}
                                        hasError={this.state.showErrors}/>
                                </div>
                            </div>
                            <div className="row pb-3 mb-3">
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputRange position="right" id={'precio'}
                                                min={minPrice} max={9999999}
                                                label={CALCULATOR.PRICE}
                                                required={true}
                                                maxLength={7}
                                                step={100}
                                                helpText={`Mínimo ${formatCurrency(
                                                    minPrice, COUNTRY_INITIALS.MEXICO, '$', 0)}`}
                                                hasError={this.state.showErrors}
                                                labelError={this.props.priceField.error}
                                                defaultValue={priceSelected}
                                                colorSelected="#7859AB" colorBackGround="#b3b3b3"
                                                isCurrency={true}
                                                disabled={true}
                                                currencyFormat={COUNTRY_INITIALS.MEXICO}
                                                onChangeBox={this.props.onChangePrice}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputRange position="right" id={'year'}
                                                min={minYear} max={maxYear}
                                                maxLength={4}
                                                label={CALCULATOR.YEAR}
                                                required={true}
                                                disabled={true}
                                                step={1}
                                                helpText={!!yearSelectedField.error ?
                                                    `Mínimo ${minYear}, Máximo ${maxYear}` : ''}
                                                showValueOnMouseUp={false}
                                                hasError={this.state.showErrors}
                                                labelError={this.props.yearSelectedField.error}
                                                defaultValue={selectedYear}
                                                colorSelected="#7859AB" colorBackGround="#b3b3b3"
                                                onChangeBox={(value, error) =>
                                                    this.onChangeYear(value, error, maxYear)}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputRange position="right" id={'enganche'}
                                                min={parseInt(this.props.minDownPaymentValue, 10)}
                                                max={maxRange}
                                                label={CALCULATOR.ENTRY_MX}
                                                required={true}
                                                maxLength={7}
                                                step={100}
                                                helpText={`Mínimo ${formatCurrency(
                                                    minDownPaymentValue, COUNTRY_INITIALS.MEXICO, '$', 0)}`}
                                                hasError={this.state.showErrors}
                                                labelError={this.props.downPaymentField.error}
                                                defaultValue={downPaymentSelected}
                                                colorSelected="#7859AB" colorBackGround="#b3b3b3"
                                                isCurrency={true}
                                                currencyFormat={COUNTRY_INITIALS.MEXICO}
                                                onChangeBox={this.props.onChangeDownPayment}
                                                showHelpText={false}/>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col">
                                    <Options id={'insurances'}
                                             name={'insurances'}
                                             options={this.props.insuranceIncludesOptions}
                                             onChange={this.props.onChangeIncludeInsurance}
                                             listGroupClass="list-group-borderless"
                                             customClassLabel="small-text"
                                             defaultValue={this.props.hasInsurance}/>
                                    {this.props.failInsurance &&
                                    <strong className="form-text is-invalid">{ERROR.NO_BITUAJ_RESULT_WARNING}</strong>
                                    }
                                </div>
                            </div>
                            <div className="row turbo-wizard-info mt-4">
                                <div className="col small">
                                    * Tasa mensual con IVA 1.96%
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-12 side-calculator">
                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        <div className="col">
                                            {this.renderQuotas()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-2 mb-3">
                    <div className="col col-md-6 mt-4">
                        <Button text={CALCULATOR.DONT_WANT_CONTINUE} onPress={this.props.onPressNoAcceptQuote}
                                customClass="rounded btn-block px-md-5 btn-outline-info"/>
                    </div>
                    <div className="col col-md-6 d-flex justify-content-end mt-4 order-btn-simulator">
                        <Button text={CALCULATOR.WANT_CONTINUE} onPress={this.onPressAcceptQuote}
                                customClass="btn-block px-md-5"/>
                    </div>
                </div>
                <div className="row mt-2 mb-3 wizard-turbo-footer">
                    <div className="col d-flex justify-content-between mt-5">
                        <p className="footer-text">Si tienes dudas llámanos al (55) 4161-8830</p>
                        <p className="text-muted small text-center text-md-right">
                            Con el respaldo de:
                            <a href="http://www.seminuevos.com/">
                                <img className="navbar-brand-img-md pl-1" alt="seminuevos"
                                     src={AssetsManager('/assets/images/common/logo-seminuevos.svg')}/>
                            </a>
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default SimulatorProfileView;
